
export enum LOCALE_KEY {
  ENGLISH = 'en',
  GERMAN = 'de',
  FRENCH = 'fr',
  SPANISH = 'es',
  ITALIAN = 'it',
  RUSSIAN = 'ru',
  PORTUGUESE = 'pt',
  TURKISH = 'tr',
  DUTCH = 'nl',
  SWEDISH = 'se',
  POLISH = 'pl',
  NORWEGIAN = 'no',
  INDONESIAN = 'id',
  DANISH = 'dk',
  MANDARIN = 'zh',
  JAPANESE = 'ja',
  MEXICAN_SPANISH = 'es-MX',
  CZECH = 'cs',
  CANTONESE = 'zh-MY',
  ENGLISH_US = 'en-US',
  PORTUGUESE_BRAZILIAN = 'pt-BR',
  UKRAINIAN = 'uk',
  VIETNAMESE = 'vi'
}

export const languageLabels = {
  [LOCALE_KEY.ENGLISH]: 'language_en',
  [LOCALE_KEY.GERMAN]: 'language_de',
  [LOCALE_KEY.FRENCH]: 'language_fr',
  [LOCALE_KEY.SPANISH]: 'language_es',
  [LOCALE_KEY.ITALIAN]: 'language_it',
  [LOCALE_KEY.RUSSIAN]: 'language_ru',
  [LOCALE_KEY.PORTUGUESE]: 'language_pt',
  [LOCALE_KEY.TURKISH]: 'language_tr',
  [LOCALE_KEY.DUTCH]: 'language_nl',
  [LOCALE_KEY.SWEDISH]: 'language_se',
  [LOCALE_KEY.POLISH]: 'language_pl',
  [LOCALE_KEY.NORWEGIAN]: 'language_no',
  [LOCALE_KEY.INDONESIAN]: 'language_id',
  [LOCALE_KEY.DANISH]: 'language_dk',
  [LOCALE_KEY.MANDARIN]: 'language_zh',
  [LOCALE_KEY.JAPANESE]: 'language_ja',
  [LOCALE_KEY.MEXICAN_SPANISH]: 'language_es-MX',
  [LOCALE_KEY.CZECH]: 'language_cs',
  [LOCALE_KEY.CANTONESE]: 'language_zh-MY',
  [LOCALE_KEY.ENGLISH_US]: 'language_en-US',
  [LOCALE_KEY.PORTUGUESE_BRAZILIAN]: 'language_pt-BR',
  [LOCALE_KEY.UKRAINIAN]: 'language_uk',
  [LOCALE_KEY.VIETNAMESE]: 'language_vi'
} as const;

export const LOCALIZED_LANGUAGE_LABELS = {
  [LOCALE_KEY.ENGLISH]: 'English',
  [LOCALE_KEY.SPANISH]: 'Español (International)',
  [LOCALE_KEY.ITALIAN]: 'Italiano',
  [LOCALE_KEY.MEXICAN_SPANISH]: 'Español (México)',
};